import { waitForElm } from "./waitForElm"

export const respondToVisibility = async (
  elementId: string,
  onVisible: Function
) => {
  const element = (await waitForElm(elementId)) as HTMLDivElement
  const observer = new IntersectionObserver(
    (entries, observer) => {
      if (entries[0].isIntersecting === true) {
        onVisible(element)
        observer.disconnect()
      }
    },
    {
      threshold: [0.5]
    }
  )

  observer.observe(element)
}
